import { FC, useState } from 'react';

import {
	AiOverlayPhoto,
	findAiOverlayPhoto,
} from '../../../utils/aiPhotoOverlay';

import '../../../scss/aiPhotoOverlay.scss';

interface IAiPhotoThumbProps {
	src: string;
	mediaId: number | string;
	alt?: string;
	className?: string;
	id?: string;
	onClick?: () => void;
	showOverlay?: boolean;
	aiReview?: any;
}

const AiPhotoThumb: FC<IAiPhotoThumbProps> = ({
	src,
	mediaId,
	alt = 'product',
	className = 'photo__img',
	id,
	onClick,
	showOverlay = false,
	aiReview,
}) => {
	const overlayPhoto: AiOverlayPhoto | null =
		showOverlay && aiReview
			? findAiOverlayPhoto(aiReview, mediaId)
			: null;

	const [naturalSize, setNaturalSize] = useState<{ w: number; h: number }>({
		w: 0,
		h: 0,
	});

	const w = (overlayPhoto?.w || 0) > 0 ? overlayPhoto!.w : naturalSize.w;
	const h = (overlayPhoto?.h || 0) > 0 ? overlayPhoto!.h : naturalSize.h;
	const canDraw =
		!!overlayPhoto?.boxes?.length && w > 0 && h > 0;

	return (
		<div className='ai-photo-thumb'>
			<img
				src={src}
				className={className}
				id={id}
				alt={alt}
				onClick={onClick}
				onLoad={(event) => {
					const img = event.currentTarget;
					if (img.naturalWidth && img.naturalHeight) {
						setNaturalSize({
							w: img.naturalWidth,
							h: img.naturalHeight,
						});
					}
				}}
			/>
			{canDraw && (
				<div
					className='ai-photo-overlay ai-photo-overlay--thumb'
					aria-hidden
				>
					{overlayPhoto!.boxes.filter((box) => box.kind !== 'zone').map((box, index) => {
						const [x1, y1, x2, y2] = box.bbox;
						return (
							<div
								key={`${box.skuId || box.name}-${index}`}
								className={`ai-photo-overlay__box ai-photo-overlay__box--${box.kind || 'sku'}`}
								title={box.name}
								style={{
									left: `${(x1 / w) * 100}%`,
									top: `${(y1 / h) * 100}%`,
									width: `${((x2 - x1) / w) * 100}%`,
									height: `${((y2 - y1) / h) * 100}%`,
								}}
							/>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default AiPhotoThumb;
